import type {Params} from "next/dist/server/request/params";

export function resolvePagePath(path: string, params?: Params, trimPrefix?: ("/ROOT/src/app" | "/ROOT/app")): string
{
    if (trimPrefix && path.startsWith(trimPrefix))
        path = path.slice(trimPrefix.length);

    if (path.includes("/(") || path.includes("/@"))
        path = path.split("/").filter((segment) => !segment.startsWith("(") && !segment.startsWith("@")).join("/");

    if (params)
    {
        for (const k in params)
        {
            const slug = params[k];

            if (!slug)
                continue;
            
            if (typeof slug === "object")
            {
                const slugs = (slug as string[]).join("/");
                path = path.replaceAll(`[[...${k}]]`, slugs).replaceAll(`[...${k}]`, slugs);
            }
            else
                path = path.replaceAll(`[${k}]`, slug);
        }
    }

    return path || "/";
}
